import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { DropdownItem } from '@atlaskit/dropdown-menu';

import { Integration } from '../../types';
import { messages } from '../i18n';

interface OwnProps {
	integration: Integration;
	onClick: (event: React.MouseEvent | React.KeyboardEvent) => void;
}

const ManageIntegrationMenuItem: React.FC<OwnProps> = ({ integration, onClick }) => {
	const menuTitle = useMemo(() => {
		switch (integration) {
			case Integration.GOOGLE_SERVICE:
				return messages.revokeGoogleMenuItemTitle;
			case Integration.MICROSOFT_SERVICE:
				return messages.revokeMicrosoftMenuItemTitle;
			case Integration.PLATFORM_SLACK_SERVICE:
				return messages.manageSlackMenuItemTitle;
		}

		return undefined;
	}, [integration]);

	if (!menuTitle) {
		return null;
	}

	return (
		<DropdownItem testId={`manage-${integration}-integration-menu-item`} onClick={onClick}>
			<FormattedMessage {...menuTitle} />
		</DropdownItem>
	);
};

export default ManageIntegrationMenuItem;
